import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface AutoDetectToggleProps {
  detectComment: boolean;
  detectChat: boolean;
  onChangeComment: (value: boolean) => void;
  onChangeChat: (value: boolean) => void;
}

export function AutoDetectToggle({
  detectComment,
  detectChat,
  onChangeComment,
  onChangeChat,
}: AutoDetectToggleProps) {
  return (
    <div className="w-full bg-white border-b px-2 py-2 md:py-3">
      <div className="flex items-center gap-4 md:gap-6">
        <div className="flex items-center gap-2">
          <Switch id="detect-comment" checked={detectComment} onCheckedChange={onChangeComment} />
          <Label htmlFor="detect-comment" className="text-sm font-medium">
            Detect Comment
          </Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch id="detect-chat" checked={detectChat} onCheckedChange={onChangeChat} />
          <Label htmlFor="detect-chat" className="text-sm font-medium">
            Detect Chat
          </Label>
        </div>
      </div>
    </div>
  );
}
